export default {
  
    setAuth(state, auth) {
      state.auth = auth;
    },
  
    setNewNotificationStatus(state, status){
      state.newNotificationStatus = status;
    },

    setNotifications(state, notifications) {
      state.notifications = notifications;
    },
  
    setDevices(state, devices) {
      state.devices = devices;
    },
  
    setSelectedDevice(state, device) {      
      state.selectedDevice = device;
      state.deviceActive = false
    },
  
    setDashboardStyle(state, dash){
       localStorage.setItem("dashStyle",JSON.stringify(dash));
      state.dashStyle = JSON.parse(JSON.stringify(dash));
    },
  
    setPushToken(state, push){
      localStorage.setItem("push",JSON.stringify(push));
      state.push = push
    },
  
    setPushNull(state){
      localStorage.removeItem("push")
      state.push = null
    },

    setDeviceActive(state, status){
      state.deviceActive = status
    },

    setDeviceInfo(state, info){
      state.deviceInfo = info
    },

    setDeviceParams(state, params){
      state.deviceParams = params
    },

    setDeviceLastTime(state, last_time){
      state.deviceLastTime = last_time
    },
    
    setCompanies(state, company_list){
      state.companies = company_list
    },

    setMqttStatus(state, mqtt_connected){
      state.mqtt_connected = mqtt_connected
    }
    
  };